import { ForbiddenState } from "@/ui";

/**
 * ForbiddenInline — the `sans-droit` state for an action gated TIGHTER than the route. The module
 * route is gated on reception.dossier.read; a sub-action (create/scan/pay…) may need another cap the
 * user lacks. ProtectedRoute can't express that, so the screen renders this in-place.
 */
export function ForbiddenInline({
  requiredCapabilities,
}: {
  requiredCapabilities: ReadonlyArray<string>;
}) {
  return <ForbiddenState requiredCapabilities={requiredCapabilities} />;
}
